import React from 'react';

const ColorPicker = ({ label, color, onChange }) => {
  return (
    <div style={{ flex: 1 }}>
      <label
        style={{
          display: 'block',
          fontSize: '0.85rem',
          color: '#677793',
          marginBottom: '0.3em'
        }}>
        {label}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
        <input
          type="color"
          value={color}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: '50px',
            height: '40px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        />
        <input
          type="text"
          value={color}
          onChange={(e) => {
            const value = e.target.value;
            // Validate hex color format
            if (/^#[0-9A-Fa-f]{0,6}$/.test(value)) {
              onChange(value);
            }
          }}
          placeholder="#000000"
          maxLength={7}
          style={{
            flex: 1,
            padding: '0.6em',
            border: '1px solid #ccc',
            borderRadius: '6px',
            fontSize: '0.9rem',
            outline: 'none',
            fontFamily: 'monospace'
          }}
        />
      </div>
    </div>
  );
};

export default ColorPicker;
